import React from 'react';
import styled from 'styled-components';
import ContactForm from '../components/ContactForm';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock } from 'react-icons/fa';
import Icon from '../components/Icon';
import { tel } from '../assets/images';

const ContactPage: React.FC = () => {
  return (
    <ContactPageContainer>
      <div className="container">
        <ContactHeader>
          <ContactTitle>Contactez-nous</ContactTitle>
          <ContactDescription>
            Vous avez des questions ou souhaitez réserver notre villa ? N'hésitez pas à nous contacter. Notre équipe est à votre disposition pour vous aider à organiser votre séjour parfait.
          </ContactDescription>
        </ContactHeader>
        
        <ContactContent>
          <ContactFormContainer>
            <ContactForm />
          </ContactFormContainer>
          
          <ContactInfo>
            <InfoSection>
              <InfoTitle>Informations de contact</InfoTitle>
              <InfoList>
                <InfoItem>
                  <InfoIcon>
                    <Icon component={FaMapMarkerAlt} />
                  </InfoIcon>
                  <InfoText>
                    <strong>Adresse</strong>
                    <p>Chemin de la Colle, 83830 Callas, France</p>
                  </InfoText>
                </InfoItem>
                
                <InfoItem>
                  <InfoIcon>
                    <Icon component={FaPhone} />
                  </InfoIcon>
                  <InfoText>
                    <strong>Téléphone</strong>
                    <PhoneImageContainer>
                      <img src={tel} alt="Numéro de téléphone" />
                    </PhoneImageContainer>
                  </InfoText>
                </InfoItem>
                
                <InfoItem>
                  <InfoIcon>
                    <Icon component={FaEnvelope} />
                  </InfoIcon>
                  <InfoText>
                    <strong>Email</strong>
                    <p>Utilisez le formulaire de contact</p>
                  </InfoText>
                </InfoItem>
                
                <InfoItem>
                  <InfoIcon>
                    <Icon component={FaClock} />
                  </InfoIcon>
                  <InfoText>
                    <strong>Horaires</strong>
                    <p>Lundi - Vendredi: 9h00 - 18h00</p>
                    <p>Samedi: 10h00 - 16h00</p>
                  </InfoText>
                </InfoItem>
              </InfoList>
            </InfoSection>
            
            <MapSection>
              <MapTitle>Airbnb</MapTitle>
              <MapContainer>
                {/* Ici, vous pourriez intégrer une carte Google Maps ou similaire */}
                <MapPlaceholder>
                  <MapText>Annonce Airbnb</MapText>
                  <MapSubtext>
                    Vous pouvez également choisir de réserver via la plateforme de location AirBnb.
                    <br />
                    <a href="https://www.airbnb.fr/rooms/1278276040389516980?guests=1&adults=1&s=67&unique_share_id=a017111f-e158-4c4f-8669-37292eef85bd" target="_blank">Voir l'annonce sur Airbnb</a>

                  </MapSubtext>
                </MapPlaceholder>
              </MapContainer>
            </MapSection>
          </ContactInfo>
        </ContactContent>
      </div>
    </ContactPageContainer>
  );
};

const ContactPageContainer = styled.div`
  padding: 12rem 0 8rem;
`;

const ContactHeader = styled.div`
  text-align: center;
  margin-bottom: 5rem;
`;

const ContactTitle = styled.h1`
  margin-bottom: 2rem;
`;

const ContactDescription = styled.p`
  max-width: 80rem;
  margin: 0 auto 3rem;
  font-size: 1.8rem;
  color: var(--color-secondary);
`;

const ContactContent = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 4rem;
  
  @media (min-width: 992px) {
    grid-template-columns: 3fr 2fr;
  }
`;

const ContactFormContainer = styled.div``;

const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
`;

const InfoSection = styled.div`
  background-color: var(--color-light);
  padding: 3rem;
  box-shadow: var(--shadow);
`;

const InfoTitle = styled.h3`
  font-size: 2.2rem;
  margin-bottom: 2.5rem;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -1rem;
    left: 0;
    width: 5rem;
    height: 2px;
    background-color: var(--color-accent);
  }
`;

const InfoList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const InfoItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
`;

const InfoIcon = styled.div`
  width: 4rem;
  height: 4rem;
  background-color: var(--color-accent);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  flex-shrink: 0;
`;

const InfoText = styled.div`
  strong {
    display: block;
    font-size: 1.6rem;
    margin-bottom: 0.5rem;
  }
  
  p {
    font-size: 1.5rem;
    color: var(--color-secondary);
    margin-bottom: 0.5rem;
  }
`;

const MapSection = styled.div`
  background-color: var(--color-light);
  padding: 3rem;
  box-shadow: var(--shadow);
`;

const MapTitle = styled.h3`
  font-size: 2.2rem;
  margin-bottom: 2.5rem;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -1rem;
    left: 0;
    width: 5rem;
    height: 2px;
    background-color: var(--color-accent);
  }
`;

const MapContainer = styled.div`
  height: 25rem;
  width: 100%;
  background-color: #f5f5f5;
  border: 1px solid rgba(0, 0, 0, 0.1);
`;

const MapPlaceholder = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
`;

const MapText = styled.p`
  font-size: 2rem;
  font-weight: 600;
  color: var(--color-secondary);
  margin-bottom: 1rem;
`;

const MapSubtext = styled.p`
  font-size: 1.4rem;
  color: var(--color-secondary);
  max-width: 25rem;
`;

const PhoneImageContainer = styled.div`
  img {
    height: 2.5rem;
    vertical-align: middle;
  }
`;

export default ContactPage;
